/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may manage cookie preferences through your browser settings. Disabling certain cookies may affect site functionality.`)
};

const es_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes administrar las preferencias de cookies a través de la configuración de tu navegador. Desactivar ciertas cookies puede afectar la funcionalidad del sitio.`)
};

const de_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie können Cookie-Einstellungen über Ihre Browsereinstellungen verwalten. Das Deaktivieren bestimmter Cookies kann die Website-Funktionalität beeinträchtigen.`)
};

const nl_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U kunt cookievoorkeuren beheren via uw browserinstellingen. Het uitschakelen van bepaalde cookies kan de functionaliteit van de site beïnvloeden.`)
};

const fr_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez gérer vos préférences de cookies via les paramètres de votre navigateur. La désactivation de certains cookies peut affecter le fonctionnement du site.`)
};

const it_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi gestire le preferenze dei cookie tramite le impostazioni del tuo browser. La disattivazione di alcuni cookie potrebbe influire sulla funzionalità del sito.`)
};

const pt_br2_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode gerenciar preferências de cookies através das configurações do seu navegador. Desativar certos cookies pode afetar a funcionalidade do site.`)
};

const pt_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode gerir as preferências de cookies através das definições do seu navegador. Desativar certos cookies pode afetar a funcionalidade do site.`)
};

const ja_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザの設定からCookieの設定を管理できます。特定のCookieを無効にすると、サイトの機能に影響する場合があります。`)
};

const zh_privacy_cookie_manage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您可以通过浏览器设置管理Cookie偏好。禁用某些Cookie可能会影响网站功能。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_cookie_manage = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_cookie_manage(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_cookie_manage", locale)
	if (locale === "en") return en_privacy_cookie_manage(inputs)
	if (locale === "es") return es_privacy_cookie_manage(inputs)
	if (locale === "de") return de_privacy_cookie_manage(inputs)
	if (locale === "nl") return nl_privacy_cookie_manage(inputs)
	if (locale === "fr") return fr_privacy_cookie_manage(inputs)
	if (locale === "it") return it_privacy_cookie_manage(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_cookie_manage(inputs)
	if (locale === "pt") return pt_privacy_cookie_manage(inputs)
	if (locale === "ja") return ja_privacy_cookie_manage(inputs)
	return zh_privacy_cookie_manage(inputs)
};